import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const useDomainsEntities = (options?: { enabled?: boolean }) => {
  const catalogApi = useApi(catalogApiRef);

  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey: ['domainEntities'],
    queryFn: async () => {
      return catalogApi.getEntities({
        filter: { kind: ['Domain'] },
        fields: [
          'metadata.name',
          'metadata.title',
          'spec.mesh.name',
          'metadata.namespace',
        ],
      });
    },
    enabled: enabled,
    staleTime: 5 * 60 * 1000, // Cache the result for 5 minutes
  });
};
